import { render } from "./ProjectConsumptionComponent.vue?vue&type=template&id=beed8102&scoped=true&ts=true"
import script from "./ProjectConsumptionComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectConsumptionComponent.vue?vue&type=script&lang=ts"

import "./ProjectConsumptionComponent.vue?vue&type=style&index=0&id=beed8102&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beed8102"]])

export default __exports__